<ng-container>
  <rt-group class="horizontal stacked">
    <div class="copy-input-wrap">
      <rt-input #copyInput [readOnly]="true" [value]="value">
        @if (hasOpenInNewTabButton) {
          <a
            suffix
            rt-icon-button
            (click)="$event.stopImmediatePropagation()"
            [href]="value"
            variant="plain"
            iconName="open-in-new"
            size="small"
            target="_blank"
            shape="square"
          >
          </a>
        }
        @if (hasEditButton) {
          <rt-icon-button
            suffix
            (click)="onEdit()"
            variant="plain"
            size="small"
            iconName="edit"
            shape="square"
          />
        }
        @if (hasCopyButton) {
          <rt-icon-button
            suffix
            (click)="copy(copyInput)"
            variant="plain"
            size="small"
            iconName="content-copy"
            shape="square"
          />
        }
      </rt-input>
    </div>
  </rt-group>
</ng-container>
